export const ENVIRONMENT = {
  LOCALHOST: 'localhost',
  TEST: 'test',
  STAGING: 'staging',
  QDAILY: 'qdaily',
  PREPROD: 'preprod',
  RC: 'rc',
  PROD: 'prod',
  ALL: 'all',
} as const;

export const ENVIRONMENTS = [
  ENVIRONMENT.LOCALHOST,
  ENVIRONMENT.TEST,
  ENVIRONMENT.STAGING,
  ENVIRONMENT.QDAILY,
  ENVIRONMENT.PREPROD,
  ENVIRONMENT.RC,
  ENVIRONMENT.PROD,
] as const;

export type Environment = (typeof ENVIRONMENTS)[number];

export const ALL_ENVIRONMENTS = ENVIRONMENTS;

export const NON_PROD_ENVIRONMENTS = ENVIRONMENTS.filter(
  (environment): environment is Exclude<Environment, typeof ENVIRONMENT.PROD> =>
    environment !== ENVIRONMENT.PROD,
);

const isEnvironment = (value: string): value is Environment =>
  ENVIRONMENTS.some((environment) => environment === value);

const isLocalhost = (hostname: string): boolean =>
  hostname === ENVIRONMENT.LOCALHOST ||
  hostname === '127.0.0.1' ||
  hostname === '[::1]' ||
  hostname.startsWith('local.') ||
  hostname.includes('-local.');

export const parseEnvironment = (hostname: string): Environment => {
  const host = hostname.toLowerCase();

  if (isLocalhost(host)) {
    return ENVIRONMENT.LOCALHOST;
  }

  const match = /^admin-([a-z0-9]+)\.quinyx\.com$/.exec(host);
  if (match && isEnvironment(match[1])) {
    return match[1];
  }

  return ENVIRONMENT.PROD;
};

export const getCurrentEnvironment = (): Environment => {
  if (typeof window === 'undefined') {
    return ENVIRONMENT.LOCALHOST;
  }

  return parseEnvironment(window.location.hostname);
};
